module.exports = __webpack_public_path__ + "img/celine.3899ae82.jpg";